import { render, staticRenderFns } from "./MessagesControl.vue?vue&type=template&id=5b732b67&scoped=true"
import script from "./MessagesControl.vue?vue&type=script&lang=js"
export * from "./MessagesControl.vue?vue&type=script&lang=js"
import style0 from "./MessagesControl.vue?vue&type=style&index=0&id=5b732b67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b732b67",
  null
  
)

export default component.exports